import { Theme } from '@mui/material/styles';
import { radii } from './tokens';

// Define enum for border radius sizes
export enum BorderRadiusSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

/**
 * The app's three legacy sizes. `radii` in `./tokens` is the fuller eight-step
 * scale the design uses, and new code should reach for that.
 *
 * Two of these three do not sit on that scale — small is 5 against the token
 * scale's `xs: 6`, and large is 15 against `xl: 14`. Aligning them would move
 * every Card, large Button and TextField by a pixel, so it is a deliberate
 * visual change for a later pass, not something to do silently here.
 */
export const borderRadius = {
  [BorderRadiusSize.SMALL]: 5,
  [BorderRadiusSize.MEDIUM]: radii.sm, // 8 — already on the scale
  [BorderRadiusSize.LARGE]: 15,
};

// Define the shape type based on the shape property in MUI Theme
export const shape: Theme['shape'] = {
  borderRadius: borderRadius[BorderRadiusSize.MEDIUM], // Default border radius
};

// Export additional shape utility
export const getComponentRadius = (
  size: BorderRadiusSize = BorderRadiusSize.MEDIUM
) => {
  return borderRadius[size];
};
